export const getUniqueListBy = (arr, key) => {
  // @ts-ignore
  return [...new Map(arr.map((item) => [item[key], item])).values()]
}
